import { useTheme } from "@emotion/react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography
} from "@mui/material";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper";
import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardIcon2 from "static/svgs/dashboard2";
import LogoIcon2 from "static/svgs/logo2";
import { accessActions } from "../../../redux/slice/access.slice";
import { authActions } from "../../../redux/slice/auth.slice";
import { uiActions } from "../../../redux/slice/ui.slice";
import { USER_LOGOUT } from "../../../redux/types/auth.types";
import LogoutIcon from "../../../static/svgs/Logout";
import MenuIcon from "../../../static/svgs/menu";
import { getMenuItems } from "../../utils";
import { checkSinglePermission } from "../helper";
import { Drawer, DrawerHeader } from "./helper";
import layoutStyles from "./layout.module.scss";
import styles from "./sidebar.module.scss";

const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)

  const selected = useSelector(uiActions.selectors.getSelectedNav);
  const handleButtonClick = (link) => {
    navigate(link);
  };
  const handleSelect = (value, link) => {
    dispatch(uiActions.actions.setSelectedNav(value));
    handleButtonClick(link);
  };

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    dispatch({ type: USER_LOGOUT });
  };

  const menuItems = getMenuItems({
    isPortalAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_PORTAL_MANAGEMENT, userPermissions, currentUser?.role),
    isAssetAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ASSET_MANAGEMENT, userPermissions, currentUser?.role),
  })

  return (
    <Box display={"flex"}>
      <Drawer
        variant="permanent"
        open={open}
        sx={{ zIndex: 20 }}
      >
        <DrawerHeader>
          <div
            className={styles.logo}
            onClick={() => handleButtonClick("/")}
          >
            {open ? <LogoIcon2 fill={"#fff"} />
              : <DashboardIcon2 width="30" height="30" />}

          </div>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ alignSelf: open ? "flex-end" : "center", ml: 0 }}
          >
            {open ? <ChevronLeftIcon color="white" /> : <MenuIcon />}
          </IconButton>
        </DrawerHeader>
        <br />
        <List className={styles.listContainer}>
          <Box>
            {menuItems?.map((item, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  disableRipple
                  disableTouchRipple
                  className={`${styles.itemButton} ${selected === item?.label ? styles.selectedItem : ""
                    }`}
                  onClick={() => handleSelect(item?.label, item?.link)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon
                      ? React.createElement(item.icon, {
                        fill:
                          selected === item.label
                            ? theme.palette.primary.main
                            : "white",
                      })
                      : null}
                  </ListItemIcon>
                  <Typography
                    color={selected === item?.label ? "primary" : "white.main"}
                    sx={{ opacity: open ? 1 : 0 }}
                  >
                    {item?.label}
                  </Typography>
                </ListItemButton>
              </ListItem>
            ))}
          </Box>
          <Box>
            <ListItem onClick={handleLogout} disablePadding>
              <ListItemButton className={`${styles.itemButton}`}>
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <LogoutIcon />
                </ListItemIcon>
                <Typography color={"white.main"} sx={{ opacity: open ? 1 : 0 }}>
                  Logout
                </Typography>
              </ListItemButton>
            </ListItem>
          </Box>
        </List>
      </Drawer>
      <Box
        component="main"
        className={open ? layoutStyles.mainContainerOpen : layoutStyles.mainContainerClose}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Sidebar;
